import axios from 'axios';

import { parameters } from '../../constants/parameters';
import { Pagination } from '../../entities/pagination';
import { User } from '../../entities/user';
import EmployeeForm from '../../entities/form/employee';
import * as genericApi from './generic-api';

export const list = async (token: string, paramString?: object): Promise<{ items: User[]; pagination: Pagination }> => {
  const url = `${parameters.api.baseUrl}/employees-crud`;

  return genericApi.list<User>(token, url, { ...paramString, with: ['company'] });
};

export const one = async (token: string, id: string): Promise<User> => {
  const url = `${parameters.api.baseUrl}/employees-crud/${id}?with[]=company&with[]=roles`;

  return genericApi.one<User>(token, url);
};

export const update = async (token: string, id: number, data: Partial<EmployeeForm>): Promise<User | undefined> => {
  const url = `${parameters.api.baseUrl}/employees-crud/${id}`;

  return genericApi.update<EmployeeForm, User>(token, url, data);
};

export const create = async (token: string, data: Partial<EmployeeForm>): Promise<User | undefined> => {
  const url = `${parameters.api.baseUrl}/employees-crud`;

  return genericApi.create<EmployeeForm, User>(token, url, data);
};

export const remove = async (token: string, id: number): Promise<{ status: string }> => {
  const url = `${parameters.api.baseUrl}/employees-crud/${id}`;

  const res = await axios.delete(url, { headers: { Authorization: `Bearer ${token}` } });

  return res.data;
};
